/**
 * siteFacts.js — SINGLE SOURCE OF TRUTH for shared public figures and
 * positioning strings. Every page that shows a country count, a lesson
 * figure, the age range, or the account policy MUST read from here so
 * the site never contradicts itself.
 *
 * Rules:
 *   • Country count is DERIVED from the actual COUNTRIES data — never
 *     hardcoded — so it can never drift out of sync with the globe.
 *   • Lesson volume uses truthful rounded wording ("1,000+ learning
 *     experiences") rather than a precise number that changes often.
 *   • No compliance/audit claims live here — those are handled per page
 *     with neutral "designed to align with…" wording only.
 */
import { COUNTRIES } from "@/data/countries";

/** Real number of countries & territories with a complete profile (Antarctica is a region, not counted). */
export const COUNTRY_COUNT = Array.isArray(COUNTRIES) ? COUNTRIES.filter((c) => c.continent !== "antarctica").length : 0;

/** "197 countries & territories" — always matches the data. */
export const COUNTRIES_LABEL = `${COUNTRY_COUNT} countries & territories`;

/** Truthful rounded wording for the overall body of activities. */
export const LEARNING_EXPERIENCES = "1,000+ learning experiences";

/** Canonical age range shown across marketing surfaces. */
export const AGE_RANGE = "4–15";

/** One consistent account policy sentence, reused everywhere. */
export const ACCOUNT_POLICY =
  "No account needed for children — open the app and start a quest. Parents and teachers can optionally create a free account for extra features.";

/** Short child-only variant for tight spaces. */
export const CHILD_NO_ACCOUNT = "No account required for children.";

/** Publishable organisation identity (owner-confirmed). */
export const ORG_NAME = "ZEN Holdings";
